import Configuration from "../../../../config/configuration"

const Szephyr = `${Configuration?.S3_URL}Header/Szephyr.webp`
const Smazer = `${Configuration?.S3_URL}Header/Smazer.webp`
const SmampMax = `${Configuration?.S3_URL}Header/SmampMax.webp`
const SmartPanel = `${Configuration?.S3_URL}Header/SmartPanel.webp`
const Ethernetmediaconvertor = `${Configuration?.S3_URL}Header/Ethernetmediaconvertor.webp`
const Serialredundant = `${Configuration?.S3_URL}Header/Serialtoredundant.webp`
const UHFRadioModem = `${Configuration?.S3_URL}Header/UHFRadioModem.webp`
const Embeddedpc = `${Configuration?.S3_URL}Header/Embeddedpc.webp`
const Miniaturemscs = `${Configuration?.S3_URL}Header/Miniaturemscs.webp`
const Vidhuraksha = `${Configuration?.S3_URL}Header/Vidhyuraksha.webp`
const WaterQualityBoard = `${Configuration?.S3_URL}Header/Waterqualityboard.webp`
const Port16managed = `${Configuration?.S3_URL}Header/16portmanaged.webp`
const Port16unmanaged = `${Configuration?.S3_URL}Header/16portunmanaged.webp`
const Port8managed = `${Configuration?.S3_URL}Header/8portmanaged.webp`
const Port24managed = `${Configuration?.S3_URL}Header/24portmanagedport.webp`
const Dualredundant = `${Configuration?.S3_URL}Header/dualredundantPS.webp`
const DisplayControllers = `${Configuration?.S3_URL}Header/DisplayControllers.webp`
const SerialInterfaceCards = `${Configuration?.S3_URL}Header/SerialInterfaceCards.webp`
const Comingsoon = `${Configuration?.S3_URL}Header/Comingsoon.webp`

export const HeaderNavItems = [
    { name: "Home", link: "/" },
    { name: "Products", link: "" },
    { name: "Solutions", link: "" },
    { name: "Company", link: "" },
    { name: "News & Events", link: "/news" },
    { name: "Careers", link: "/careers" },
    { name: "Contact Us", link: "/support" },
]

export const companyList = [
    { name: 'About Us', link: '/aboutus' },
    { name: 'Leadership', link: '/leadership' },
];

export const ContactusButton = {
    name: "Contact Us", link: "/support"
}

export const productList = [
    { name: 'SZephyr', link: '/products/szephyr', image: Szephyr },
    { name: 'Smazer', link: '/products/smazer', image: Smazer },
    { name: 'SmampMax', link: '/products/smampmax', image: SmampMax },
    { name: 'Innomate', link: '/products/innomate', image: SmartPanel },
    { name: 'RedunLink RS232-2F', link: '/products/RedunLink_RS232-2F', image: Ethernetmediaconvertor },
    { name: 'Serial to Redundant Fibre Extender', link: '/products/serialtoredundantfiberextender', image: Serialredundant },
    { name: 'RelaiLink UHF-X', link: '/products/RelaiLink_UHF-X', image: UHFRadioModem },
    { name: 'RuggedEdge MPU-65', link: '/products/RuggedEdge_MPU-65', image: Embeddedpc },
    { name: 'InduX Edge 8', link: '/products/InduX_Edge_8', image: Miniaturemscs },
    { name: 'VidyuRaksha 2.0', link: '/products/vidyuraksha_2.0', image: Vidhuraksha },
    { name: 'SensiConnect 1612 PRO', link: '/products/SensiConnect_1612_PRO', image: WaterQualityBoard },
    // { name: 'RugEdge V3000', link: '/products/RugEdge_V3000', image: SerialInterfaceCards },
    // { name: 'RugEdge R8000', link: '/products/RugEdge_R8000', image: SerialInterfaceCards },
    { name: 'Industrial Rugged 16-Port L2 Managed Switch', link: '/products/industrialrugged16portl2managedswitch', image: Port16managed },
    { name: 'Industrial Rugged 16-Port Unmanaged Switch', link: '/products/industrialrugged16portunmanagedswitch', image: Port16unmanaged },
    { name: 'Industrial Rugged 8-Port L2 Managed Switch', link: '/products/industrialrugged8portl2managedswitch', image: Port8managed },
    { name: 'Industrial Rugged 24-Port L2 Managed Switch', link: '/products/industrialrugged24portl2managedswitch', image: Port24managed },
    { name: 'Dual Redundant Power Supply', link: '/products/dualredundantpowersupply', image: Dualredundant },
    { name: 'Display Controllers', link: '/products/displaycontrollers', image: DisplayControllers },
    { name: 'Serial Interface Cards', link: '/products/serialinterfacecards', image: SerialInterfaceCards },
    // { name: 'RugEdge R8000', link: '/products/rugedge_r8000', image: SerialInterfaceCards },
    // { name: 'RugEdge V3000', link: '/products/rugedge_v3000', image: SerialInterfaceCards },
    // { name: 'Web And Cloud Solutions', link: '/products/webandcloudsolutions', image: SerialInterfaceCards },
    // { name: 'Mobile Applications', link: '/products/mobileapplications', image: SerialInterfaceCards },

    //upcoming
    // { name: 'Smart Mutli Sensor System', link: '/products/smartmultisensorsystem', image: Comingsoon },
    // { name: 'Edge Computing Sensor Controllers ', link: '/products/edgecomputing', image: Comingsoon },
    // { name: 'The Stainless Steel External Display Controller', link: '/products/stainless', image: Comingsoon },
    // { name: 'GNSS Module', link: '/products/gnss', image: Comingsoon },
];








